import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.pedidos_api.comandas;

// Axios instance with auth interceptor (token managed automatically)
// No caching - comandas data moves very fast
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));

// =====================
// READS (no cache - real-time data)
// =====================

// /GetAllNotReadyComandasByLocalId/<int:local_id>
export const GetAllNotReadyComandasByLocalId = async (local_id: number) => {
  return await retryWithBackoff(() => api.get(`/GetAllNotReadyComandasByLocalId/${local_id}`));
};

// GetComandasByMesaId
export const GetComandasByMesaId = async (mesa_id: number) => {
  return await retryWithBackoff(() => api.get(`/GetComandasByMesaId/${mesa_id}`));
};

// /GetComandasByPedidoId/<int:pedido_id>
export const GetComandasByPedidoId = async (pedido_id: number) => {
  return await retryWithBackoff(() => api.get(`/GetComandasByPedidoId/${pedido_id}`));
};

// /PrintComandaByComandaId/<int:comanda_id>
export const PrintComandaByComandaId = async (comanda_id: number) => {
  return await retryWithBackoff(() => api.get(`/PrintComandaByComandaId/${comanda_id}`));
};

// =====================
// MUTATIONS (state changes)
// =====================

// /MarkComandaAsReady/<int:comanda_id>
export const MarkComandaAsReady = async (comanda_id: number) => {
  return await retryWithBackoff(() => api.put(`/MarkComandaAsReady/${comanda_id}`));
};

// /MarkComandaAsStarted/<int:comanda_id>
export const MarkComandaAsStarted = async (comanda_id: number) => {
  return await retryWithBackoff(() => api.put(`/MarkComandaAsStarted/${comanda_id}`));
};

// /MarkComandaAsDelivered/<int:comanda_id>
export const MarkComandaAsDelivered = async (comanda_id: number) => {
  return await retryWithBackoff(() => api.put(`/MarkComandaAsDelivered/${comanda_id}`));
};

